import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import LikesProvider from "./context/LikesProvider";
import NavBar from "./components/NavBar";
import ListingDetails from "./components/ListingDetails";
import Login from "./components/Login";
import Signup from "./components/Signup";
import Logout from "./components/Logout";
import Profile from "./components/Profile";
import Footer from "./components/Footer";

import FreeMarketAnalysis from "./components/FreeMarketAnalysis";
import Home from "./Home";
import client from "./sanityClient";

import FeaturedListingDetail from "./components/FeaturedListingDetail";
import FirstVisitPopup from "./components/FirstVisitPopop";
import "./App.css";

import FeaturedListings from "./components/FeaturedListings";
import About from "./components/About";
import MortgageCalculator from "./components/MortgageCalculator";
import CommunityShowcase from "./components/CommunityShowcase";
import WaterRightTransactions from "./components/WaterRightTransactions";
import ContactForm from "./components/ContactForm";
// import GoogleTrends from "./components/GoogleTrends";
import TrendsComponent from "./components/TrendsComponent";
import IFrameComponent from "./components/IFrameComponent";
import NeighborhoodGuides from "./components/NeighborhoodGuides";
import Neighborhood from "./components/Neighborhood"; // Assuming that this is the import for your Neighborhood component
import AdvancedSearch from "./components/AdvancedSearch";
import CommunityPage from "./components/CommunityPage";
import SoldListings from "./components/SoldListings";
import Testimonials from "./components/Testimonials";
import Sell from "./components/Sell";

function ScrollToTop() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return null;
}

function App() {
 

  const [popupVisible, setPopupVisible] = useState(() => {
    const firstVisit = localStorage.getItem("firstVisit");
    return firstVisit === null || firstVisit === "true";
  });

  const closePopup = () => {
    setPopupVisible(false);
    localStorage.setItem("firstVisit", "false");
  };



  return (
    <Router>
      <ScrollToTop />
      <AuthProvider>
        {/* <GoogleTrends /> */}
        <LikesProvider>
          {popupVisible && <FirstVisitPopup closePopup={closePopup} />}
          <NavBar />

          <Routes>
            <Route
              path="/"
              element={
                <Home 
                 />
              }
            />
            <Route path="/property/:id" element={<ListingDetails />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/logout" element={<Logout />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/featured-listings" element={<FeaturedListings />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<ContactForm />} />
            <Route path="/frame" element={<IFrameComponent />} />
            <Route path="/sell" element={<Sell />} />

            <Route
              path="/neighborhood/:neighborhoodSlug"
              element={<Neighborhood />}
            />

            <Route
              path="/neighborhood-guide"
              element={<NeighborhoodGuides />}
            />
            <Route path="/commy" element={<CommunityPage />} />

            <Route path="/calculator" element={<MortgageCalculator />} />
            <Route path="/quick-search" element={<IFrameComponent />} />
            <Route path="/advanced-search" element={<AdvancedSearch />} />

            <Route path="/com" element={<CommunityShowcase />} />
            <Route path="/trends" element={<TrendsComponent />} />
            <Route path="/stories" element={<Testimonials />} />


            {/* <Route
              path="/properties"
              element={<Properties properties={properties} />}
            /> */}
            <Route
              path="/water-right-transactions"
              element={<WaterRightTransactions />}
            />
            <Route
              path="/free-market-analysis"
              element={<FreeMarketAnalysis />}
            />
            <Route
              path="/featured-listing/:slug"
              element={<FeaturedListingDetail />}
            />
            <Route path="/recently-sold" element={<SoldListings />} />
            <Route path="/neighborhoods" element={<NeighborhoodGuides />} />
          </Routes>

          <Footer />
        </LikesProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;
